import { render, staticRenderFns } from "./AddressFormContainer.vue?vue&type=template&id=080d945a&scoped=true&"
import script from "./AddressFormContainer.vue?vue&type=script&lang=js&"
export * from "./AddressFormContainer.vue?vue&type=script&lang=js&"
import style0 from "./AddressFormContainer.vue?vue&type=style&index=0&id=080d945a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d945a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VForm,VRow})
